var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sizer-div",attrs:{"id":`tileSizerDiv_${_vm.tile.key}`}}),_c('Container',{staticClass:"tile-container",attrs:{"collapsable":false,"id":`tileResultContainer_${_vm.tile.key}`},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.getLabel(_vm.tile)))]},proxy:true},{key:"content",fn:function(){return [_vm._t("content",function(){return [_vm._v(_vm._s(_vm.tile.type == 'boolean'
          ? _vm.record[_vm.tile.key]
            ? 'Yes'
            : 'No'
          : typeof _vm.record[_vm.tile.key] == 'number'
          ? _vm.record[_vm.tile.key].toLocaleString('en-US')
          : _vm.record[_vm.tile.key]))]})]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }